export const CONTRACT_SERVICE = 'contract'
export const AVTALA_BACKEND = 'avtala'
export const GROUP_CONTRACT = 'contract'
export const GROUP_CRM = 'crm'
export const CONTRACT_TYPE = 'type'
export const CONTRACT_ROLE = 'role'
export const CONTRACT_CATEGORY = 'category'
export const CONTRACT_STATUS = 'status'
export const CURRENCY = 'currency'
export const CONTACT_SERVICE = 'contact'
export const COMMENT_SERVICE = 'comment'
export const POLICY_SERVICE = 'policy'
export const FOLLOW_UP_SERVICE = 'followup'
export const EMAIL_SERVICE = 'email'
export const EXPORT_SERVICE = 'export'
export const SIGN_SERVICE = 'sign'
export const INVOICE_SERVICE = 'invoice'
